module.exports = "./dist/assets/images/icons/6e52452c8593b19a79b61e8971104e49.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/logo_soleco.png
// module id = ./assets/images/icons/logo_soleco.png
// module chunks = 0